import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.config.productionTip = false

//引入config配置文件
import config from './static/js/config.js';
Vue.prototype.config = config;
Vue.use(ElementUI);

// 使用 vue-meta
import Meta from "vue-meta";
Vue.use(Meta);

new Vue({ 
  router,
  render: h => h(App),
}).$mount('#app')
document.title = config.site.name;
